import { c as _c } from "react/compiler-runtime";
const ArrowRight = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M23 5.086 41.914 24 23 42.914l-2.828-2.828L34.257 26H6.178v-4h28.08L20.171 7.914 23 5.086z" /></svg>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default ArrowRight;